'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlackBackground = exports.RedBackground = exports.YellowBackground = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YellowBackground = exports.YellowBackground = function (_React$Component) {
  (0, _inherits3.default)(YellowBackground, _React$Component);

  function YellowBackground() {
    (0, _classCallCheck3.default)(this, YellowBackground);
    return (0, _possibleConstructorReturn3.default)(this, (YellowBackground.__proto__ || (0, _getPrototypeOf2.default)(YellowBackground)).apply(this, arguments));
  }

  (0, _createClass3.default)(YellowBackground, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { style: { background: 'yellow', width: '100%', height: '100%' } });
    }
  }]);
  return YellowBackground;
}(_react2.default.Component);

var RedBackground = exports.RedBackground = function (_React$Component2) {
  (0, _inherits3.default)(RedBackground, _React$Component2);

  function RedBackground() {
    (0, _classCallCheck3.default)(this, RedBackground);
    return (0, _possibleConstructorReturn3.default)(this, (RedBackground.__proto__ || (0, _getPrototypeOf2.default)(RedBackground)).apply(this, arguments));
  }

  (0, _createClass3.default)(RedBackground, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { style: { background: 'red', width: '100%', height: '100%' } });
    }
  }]);
  return RedBackground;
}(_react2.default.Component);

var BlackBackground = exports.BlackBackground = function (_React$Component3) {
  (0, _inherits3.default)(BlackBackground, _React$Component3);

  function BlackBackground() {
    (0, _classCallCheck3.default)(this, BlackBackground);
    return (0, _possibleConstructorReturn3.default)(this, (BlackBackground.__proto__ || (0, _getPrototypeOf2.default)(BlackBackground)).apply(this, arguments));
  }

  (0, _createClass3.default)(BlackBackground, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { style: { background: 'black', width: '100%', height: '100%' } });
    }
  }]);
  return BlackBackground;
}(_react2.default.Component);